import { render, staticRenderFns } from "./VirtualKeyboard65LessSplit.vue?vue&type=template&id=2a0808c6&scoped=true&"
import script from "./VirtualKeyboard65LessSplit.vue?vue&type=script&lang=js&"
export * from "./VirtualKeyboard65LessSplit.vue?vue&type=script&lang=js&"
import style0 from "./VirtualKeyboard65LessSplit.vue?vue&type=style&index=0&id=2a0808c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0808c6",
  null
  
)

export default component.exports